<div class="flex-column d-flex gap-4 driver-dashboard">
  <div class="row driver-dashboard__header align-items-center">
    <div class="col-lg-9 col-md-12 align-self-center">
      <h2 class="h3 m-0">{{ 'driverDashboard.title' | transloco }}</h2>
    </div>
    <div class="col-lg-3 col-md-12 px-0">
      <div class="input-group">
        <app-account-filter [filter]="accountFilter" class="w-100 py-2"
          (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
      </div>
    </div>
  </div>

  <div class="row gx-4">
    <div class="col-lg-3 col-md-6">
      <app-drivers-in-yard-widget></app-drivers-in-yard-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-drivers-in-vehicle-widget></app-drivers-in-vehicle-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-drivers-en-route-widget></app-drivers-en-route-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-stationary-drivers-widget></app-stationary-drivers-widget>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-9 col-md-12">
      <div class="driver-dashboard-table__wrapper">
        <div class="driver-dashboard-table__container">
          <app-driver-status-table (loadingChange)="onLoadingChange($event)"></app-driver-status-table>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-12">
      <div class="driver-dashboard__basemap h-100">
        <app-dashboard-driver-map [isLoading]="isStatusTableLoading"></app-dashboard-driver-map>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-9 col-md-12">
      <div class="row h-100">
        <div class="col-lg-6 col-md-12">
          <app-highest-overtime-graph></app-highest-overtime-graph>
        </div>
        <div class="col-lg-6 col-md-12">
          <app-driver-utilisation-graph></app-driver-utilisation-graph>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-12">
      <app-frequent-stops-graph></app-frequent-stops-graph>
    </div>
  </div>
</div>